module.exports = __webpack_public_path__ + "assets/images/office_cita.be8c844d76330dfb40fb4a715c904537.png";